/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import { TravelerProfile } from '@marageti/z4-sdk/lib/people';
import TripRequestDetailsSidebarView from './trip-request-details-sidebar-view';
import { useAuthStore } from '../../../store';

type TripRequestDetailsSidebarContainerProps = {
  tripRequestId: string;
};

const TripRequestDetailsSidebarContainer = ({
  tripRequestId,
}: TripRequestDetailsSidebarContainerProps) => {
  const apiClient = useApiClient();
  const tripRequest = useFetch<TripRequest>(
    apiClient.tripRequestsClient.getTripRequest,
    [tripRequestId],
    !!tripRequestId,
  );
  const { loggedInTeamMember } = useAuthStore();
  const travelers = tripRequest.data?.travelers;
  const primaryTraveler = travelers?.[0];

  const travelerProfile = useFetch<TravelerProfile>(
    apiClient.peopleClient.getTravelerProfile,
    [primaryTraveler?.id],
    !!primaryTraveler?.id,
  );

  const handleEdit = () => {
    travelerProfile.mutate();
    tripRequest.mutate();
  };

  const error = tripRequest.error || travelerProfile.error;

  return (
    <TripRequestDetailsSidebarView
      error={error}
      loggedInTeamMember={loggedInTeamMember}
      travelers={travelers}
      travelerId={primaryTraveler?.id}
      tripRequest={tripRequest.data}
      onTravelerEdit={handleEdit}
      onEditSuccess={handleEdit}
    />
  );
};

export default TripRequestDetailsSidebarContainer;
